import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Download, Mail } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

function fmt(d) {
  try { return new Date(d).toLocaleDateString("de-CH", { dateStyle: "medium" }); } catch { return ""; }
}

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/newsletter").then(({ data }) => setItems(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const del = async (email) => {
    await api.delete(`/admin/newsletter/${encodeURIComponent(email)}`).catch(() => toast.error("Fehler"));
    setItems((x) => x.filter((i) => i.email !== email));
    toast.success("Abonnent entfernt");
  };

  const exportCsv = () => {
    const rows = [["E-Mail", "Angemeldet am"], ...items.map((i) => [i.email, i.created_at || ""])];
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `gysumo-newsletter-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="fade-in">
      <div className="flex items-center justify-between gap-4 mb-8 flex-wrap">
        <h1 className="font-serif text-4xl font-light">Newsletter</h1>
        <Button onClick={exportCsv} disabled={items.length === 0} data-testid="newsletter-export" className="bg-[#632A8E] text-white hover:bg-[#9A4DCC] rounded-md">
          <Download className="w-4 h-4 mr-2" /> CSV exportieren
        </Button>
      </div>
      <p className="text-[#6E5A82] mb-6" data-testid="newsletter-count">{items.length} Interessent{items.length === 1 ? "" : "en"}</p>
      {loading ? (
        <p className="text-[#9A86B4]">Laden…</p>
      ) : items.length === 0 ? (
        <p className="text-[#9A86B4]">Noch keine Newsletter-Anmeldungen.</p>
      ) : (
        <div className="bg-white border border-[#E7D8C6] divide-y divide-[#F5EBDB]" data-testid="newsletter-list">
          {items.map((i) => (
            <div key={i.email} className="flex items-center justify-between gap-4 px-5 py-3" data-testid={`newsletter-item-${i.email}`}>
              <div className="flex items-center gap-3 min-w-0">
                <Mail className="w-4 h-4 text-[#9A86B4] shrink-0" />
                <span className="text-[#32104F] truncate">{i.email}</span>
              </div>
              <div className="flex items-center gap-4 shrink-0">
                <span className="text-xs text-[#9A86B4]">{fmt(i.created_at)}</span>
                <Button size="icon" variant="ghost" onClick={() => del(i.email)} data-testid={`newsletter-delete-${i.email}`}>
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
